<template>
  <div class="router-header flex flex-wrap items-center mb-6">
    <div
      class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
    >
      <h2 class="mb-1 pln-color">{{ title }}</h2>
    </div>

    <!-- BREADCRUMB -->
    <vx-breadcrumb
      class="ml-4 md:block hidden"
      :route="routes"
      :isRTL="false"
    />
  </div>
</template>
<script>
export default {
  props: ["title", "routes"],
};
</script>
